<div class="row mt-3 mx-2">
  <div class="col-md-5 align-self-start">
    <div class="card border-0 h-100" style="box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05)">
      <div class="card-header bg-white py-1 border-bottom-0">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0 fw-normal d-flex align-items-center">
            <div class="form-check mb-0 me-2" *ngIf="unassignedElements.length">
              <input class="form-check-input" type="checkbox" id="selectAllUnassigned{{ id }}" [checked]="allUnassignedVisibleSelected" (change)="toggleAllUnassigned($any($event.target).checked)" data-tmw-tooltip="Tout sélectionner / désélectionner" />
              <label class="form-check-label visually-hidden" for="selectAllUnassigned{{ id }}">Tout sélectionner</label>
            </div>
            <span class="align-middle" [tmwTranslate]="fromTitleKey"></span>
            <span class="badge bg-light text-primary rounded-pill ms-1">{{ unassignedElements.length }}</span>
          </h6>
          <a *ngIf="enableFilter" (click)="term = ''; filtrer = !filtrer" data-tmw-tooltip="Filtrer" class="btn btn-sm btn-light">
            <i class="bi bi-search"></i>
          </a>
        </div>
      </div>
      <div class="card-body p-0 overflow-auto" style="max-height: 200px">
        <div *ngIf="filtrer" class="px-3 pt-3">
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text bg-white border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input type="text" name="field_filter" class="form-control form-control-sm border-start-0" [placeholder]="'...'" [(ngModel)]="term" autocomplete="off" style="height: 30px" />
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <tbody>
              @for (unassignedElement of unassignedElements | tmwFilterBy: term; track unassignedElement[keyField]) {
                <tr class="align-middle" style="cursor: pointer; height: 32px">
                  <td class="w-25 ps-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" name="selectionne{{ $index }}" id="selectedField{{ id }}_{{ unassignedElement[keyField] }}" [checked]="unassignedElement.selected" (change)="addToList(unassignedElement)" />
                      <label class="form-check-label" for="selectedField{{ id }}_{{ unassignedElement[keyField] }}"></label>
                    </div>
                  </td>
                  <td>
                    <label class="form-check-label" for="selectedField{{ id }}_{{ unassignedElement[keyField] }}">
                      @if (translateLabels) {
                        <span [tmwTranslate]="unassignedElement[labelFiled]"></span>
                      } @else {
                        {{ unassignedElement[labelFiled] }}
                      }
                    </label>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-2 align-self-center text-center">
    <div class="d-flex flex-column align-items-center justify-content-center gap-3">
      <button type="button" class="btn btn-outline-primary btn-sm w-75 d-flex justify-content-between align-items-center py-1" (click)="assignSelected()" [disabled]="isSaving">
        <span adcTranslate="entity.action.affecter">Affecter </span>
        <span class="d-flex align-items-center">
          <span class="badge bg-light text-primary me-1">{{ toAssignList.length }}</span>
          <span class="fa fa-chevron-right"></span>
        </span>
      </button>
      <button type="button" class="btn btn-outline-primary btn-sm w-75 d-flex justify-content-between align-items-center py-1" (click)="unassignSelected()" [disabled]="isSaving">
        <span class="d-flex align-items-center">
          <span class="fa fa-chevron-left"></span>
          <span class="badge bg-light text-primary ms-1">{{ toUnassignList.length }}</span>
        </span>
        <span adcTranslate="entity.action.delete">Supprimer</span>
      </button>
    </div>
  </div>
  <div class="col-md-5 align-self-start">
    <div class="card border-0 h-100" style="box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05)">
      <div class="card-header bg-white py-1 border-bottom-0">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0 fw-normal d-flex align-items-center">
            <div class="form-check mb-0 me-2" *ngIf="assignedElements.length">
              <input class="form-check-input" type="checkbox" id="selectAllAssigned{{ id }}" [checked]="allAssignedVisibleSelected" (change)="toggleAllAssigned($any($event.target).checked)" data-tmw-tooltip="Tout sélectionner / désélectionner" />
              <label class="form-check-label visually-hidden" for="selectAllAssigned{{ id }}">Tout sélectionner</label>
            </div>
            <span class="align-middle" [tmwTranslate]="toTitleKey"></span>
            <span class="badge bg-light text-primary rounded-pill ms-1">{{ assignedElements.length }}</span>
          </h6>
          <a *ngIf="enableFilter" (click)="term2 = ''; filtrer2 = !filtrer2" data-tmw-tooltip="Filtrer" class="btn btn-sm btn-light">
            <i class="bi bi-search"></i>
          </a>
        </div>
      </div>
      <div class="card-body p-0 overflow-auto" style="max-height: 200px">
        <div *ngIf="filtrer2" class="px-3 pt-3">
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text bg-white border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input type="text" name="field_filter" class="form-control form-control-sm border-start-0" [placeholder]="'...'" [(ngModel)]="term2" autocomplete="off" style="height: 30px" />
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <tbody>
              @for (assignedElement of assignedElements | tmwFilterBy: term2; track assignedElement[keyField]) {
                <tr class="align-middle" style="cursor: pointer; height: 32px">
                  <td class="w-25 ps-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" name="affectation{{ $index }}" id="assignField{{ id }}_{{ assignedElement[keyField] }}" [checked]="assignedElement.selected" (change)="delFromList(assignedElement)" />
                      <label class="form-check-label" for="assignField{{ id }}_{{ assignedElement[keyField] }}"></label>
                    </div>
                  </td>
                  <td>
                    <label class="form-check-label" for="assignField{{ id }}_{{ assignedElement[keyField] }}">
                      @if (translateLabels) {
                        <span [tmwTranslate]="assignedElement[labelFiled]"></span>
                      } @else {
                        {{ assignedElement[labelFiled] }}
                      }
                    </label>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
